<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col">
          <center>
            <img v-if="imageBase64.length" :src="imageBase64" class="rounded h-48" style="transform: scale(0.5, 0.5)" />
            <img v-else :src="data.avatar" style="transform: scale(0.5, 0.5);max-height:300px" />
          </center>
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data.name }}</p>
            <input type="file" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">
          </div>
        </div>
      </div>
      <div class="vx-col w-full">
        <vs-button class="mr-4 mb-8 mt-8 float-right" @click="$refs.update_avatar_input.click()">Change Profile Image</vs-button>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col w-full mx-4">
      <h4>Update your details</h4>

        <vs-input class="w-full mt-4" label="Display Name" v-model="data.displayName" v-validate="'required'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="Contact Email" v-model="data.email" type="email" v-validate="'required|email'" name="email" />
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <ul class="con-s mt-4">
          <li>
            <label for="">Profile active</label>
            <vs-switch class="mb-2 mt-2" v-model="data.activated"/>
            <small>Note: disabling your profile will disable all your tags</small>
          </li>
        </ul>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 mr-4 flex float-right">
          <vs-button class="mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      imageBase64: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes () {
      this.$fs.collection('client').doc(this.userId).update({
        displayName: this.data.displayName || '',
        email: this.data.email || '',
        avatar: this.imageBase64 || '',
        activated: this.data.activated
      })
        .then(() => {
          this.$vs.notify({
            title: 'Updated',
            text: 'Your details have been updated',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success',
            position: 'top-center'
          })
        })
        .catch(error => {
          console.log(error)
          this.$vs.notify({
            title: 'Oops',
            text: 'Something went wrong, please try again.',
            iconPack: 'feather',
            icon: 'icon-frown',
            color: 'danger',
            position: 'top-center'
          })
        })
    },
    reset_data () {
      this.data = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar (file) {
      const reader = new FileReader()
      const img = new Image()
      reader.readAsDataURL(file.target.files[0])
      reader.addEventListener('load', () => {
        img.src = reader.result
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        img.addEventListener('load', () => {
          const MAX_WIDTH = 400
          const MAX_HEIGHT = 400
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            /* eslint-disable */
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height

          /* change opaque pixels to white */
          const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height)
          let data = imgData.data
          for(var i = 0; i < data.length; i += 4) {
              if (data[i+3] < 255) {
                  data[i] = 255
                  data[i+1] = 255
                  data[i+2] = 255
                  data[i+3] = 255
              }
          }
          ctx.putImageData(imgData, 0, 0)

          ctx.drawImage(img, 0, 0, width, height)
          this.imageBase64 = canvas.toDataURL('image/jpeg')
        })
      }, false)
    }
  }
}
</script>
